import type { ReactNode } from 'react'

export const Field = ({
  id,
  label,
  hint,
  error,
  children,
}: {
  id: string
  label: string
  hint?: string
  error?: string
  children: (ids: { id: string; describedBy: string | undefined }) => ReactNode
}) => {
  const described = [hint === undefined ? null : `${id}-hint`, error === undefined ? null : `${id}-error`].filter(
    (value): value is string => value !== null,
  )
  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      {children({ id, describedBy: described.length === 0 ? undefined : described.join(' ') })}
      {hint === undefined ? null : (
        <p className="field-hint" id={`${id}-hint`}>
          {hint}
        </p>
      )}
      {error === undefined ? null : (
        <p className="field-error tone-danger" id={`${id}-error`} role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
